import React from 'react';
import { Card, Col, Image, Row } from 'react-bootstrap';
import dashboard from '../../images/dashboard.png'
const Dashboard = () => {
    return (
              
           
            <Row data-aos="zoom-in" data-aos-easing="ease-out-cubic"
            data-aos-duration="1000" className='project-div mt-4'>
                  <Col xs={12} sm={12} md={6}>
                  <Image src={dashboard} rounded fluid />
                      
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                      <p style={{fontFamily:'Montserrat',color:'rgb(90, 89, 89)',fontWeight:'700'}}>Dashboard</p>
                      <p style={{fontSize:'14px',color:'rgb(90, 89, 89)'}}>
                          <span style={{fontWeight:'700'}}>User</span>
                      </p>
                      <p style={{fontSize:'14px'}}>
                      A user needs to log in first. Then dashboard will visible to a user. Where user can manage his order, add review 
                      </p>
                      <p style={{fontSize:'14px',color:'rgb(90, 89, 89)'}}>
                          <span style={{fontWeight:'700'}}>Admin</span>
                      </p>
                      <p style={{fontSize:'14px'}}> Admin should log in with Id(admin@admin.com)
                    and Password (123456) for dashboard access. Admin can manage orders. He can confirm order, delete order. He can also make another admin.</p>
                 
                   
                  </Col>
              </Row>
            
      
    );
};

export default Dashboard;